import Cookies from 'js-cookie';

import { ZRM_API } from '../constants/FeatureFlagConstants';

/**
 * Get all cookies as a key-value object
 */
export function getCookies(): Record<string, string> {
  return Cookies.get() as Record<string, string>;
}

/**
 * Get a specific cookie value
 */
export function getCookie(name: string): string | undefined {
  return Cookies.get(name);
}

/**
 * Reads the ZRM_API override cookie (set via /rental-manager/featureFlags) that lets
 * engineers point the app at an alternate backend without rebuilding.
 */
export function getZrmApiOverride(): string | undefined {
  return getCookie(ZRM_API);
}

/**
 * Set a cookie with custom converter to override default encoding behavior
 */
export function setCookie(name: string, value: string): void {
  // Custom converter to override default encoding behavior for special characters `%`
  // https://github.com/js-cookie/js-cookie#encoding
  Cookies.withConverter({
    write: (val: string | object): string => (typeof val === 'string' ? val : JSON.stringify(val)),
  }).set(name, value, {
    path: '/' as const,
    // @ts-expect-error - sameSite 'none' not in CookieAttributes type
    sameSite: 'none' as const,
    secure: true,
    expires: 1,
  });
}

/**
 * Set multiple cookies at once
 */
export function setCookies(cookies: Record<string, string>): void {
  Object.entries(cookies).forEach(([name, value]) => {
    setCookie(name, value);
  });
}

/**
 * Parse cookie value as boolean
 */
export function getCookieAsBoolean(name: string, defaultValue = false): boolean {
  const value = getCookie(name);
  if (value === undefined) {
    return defaultValue;
  }
  return value === 'true' || value === '1';
}
